export enum ClaimStatus {
    None = "None",
    New = "New",
    Pending = "Pending",
    Closed = "Closed",
    Denied = "Denied",
    Cancelled = "Cancelled",
}
